import { useEffect, useState } from "react";
import { APIHandlerV2 } from "hooks/api-handler-v2";
export function UseLazyApiCallV2({ url, method, paramsData }: any) {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>();

  async function getData(props: any) {
    const localData = props?.params || paramsData;
    const localUrl = props?.url || url;

    let apiResponseInitial = null;

    try {
      setIsLoading(true);
      const data: any = await APIHandlerV2({
        method,
        url: localUrl,
        data: localData,
      });

      setData(data);
      apiResponseInitial = data;
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
    return apiResponseInitial;
  }

  return [getData, { data, isLoading, error }];
}
